export const GET_DUPLICATE_ATTENDANCE = 'GET_DUPLICATE_ATTENDANCE'
export const GET_DUPLICATE_ATTENDANCE_DATE = 'GET_DUPLICATE_ATTENDANCE_DATE'
export const GET_ATTENDANCE_STATUS_PRESENT = 'GET_ATTENDANCE_STATUS_PRESENT'
export const GET_ATTENDANCE_STATUS_BUNK = 'GET_ATTENDANCE_STATUS_BUNK'
